import React from "react";
import { Button, ArrowLeftIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TonalButtonWithStartIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Tonal button with start icon"}
        value={
          '<Button variant={"tonal"} startIcon={<ArrowLeftIcon />} color={"info"}>Back</Button>'
        }
      >
        <Button variant={"tonal"} startIcon={<ArrowLeftIcon />} color={"info"}>
          Back
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TonalButtonWithStartIcon;
